module.exports = __webpack_public_path__ + "icon-pause.c0328ad2f338926b8d06.svg";


//////////////////
// WEBPACK FOOTER
// /Users/benmeden/Documents/Projects/Maestro/abem-examiner-demo/src/assets/icons/icon-pause.svg
// module id = ../../../../../src/assets/icons/icon-pause.svg
// module chunks = styles